import React from 'react';
import './Home.css';
import Me from '../../assets/avatar-1.jpeg';
import HeaderSocials from './HeaderSocials';
import ScrollDown from './ScrollDown';
import Shapes from './Shapes';

const Home = () => {
    return (
        <section className="home container" id='home'>
            <div className="intro">
                <img src={Me} alt="Abhay Sahgal" className='home__img' width='120' />
                <h1 className="home__name">Abhay Sahgal</h1>
                <span className="home__education">I'm a Software Engineer</span>

                <HeaderSocials />

                <a href="#contact" className="contact__button">Contact Me</a>

                <ScrollDown />
            </div>

            <Shapes />
        </section>
    );
};

export default Home;
